export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";